module.exports = __webpack_public_path__ + "assets/224e54f0c11f7a05d434ab580c539d12.mp3";